import { render } from "./MiezzMenuTab.vue?vue&type=template&id=efd68792&scoped=true&ts=true"
import script from "./MiezzMenuTab.vue?vue&type=script&lang=ts"
export * from "./MiezzMenuTab.vue?vue&type=script&lang=ts"

import "./MiezzMenuTab.vue?vue&type=style&index=0&id=efd68792&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efd68792"]])

export default __exports__